import React, {Component} from "react";
import {injectIntl} from "react-intl";
import SADropdown from "../../common/dropdown/SADropdown";
import connect from "react-redux/es/connect/connect";
import {Checkbox, Upload} from "antd";
import SAInputNumber from "../../common/input/SAInputNumber";
import Constants from "../../../services/Constants";

import "./TiresReplacement.css";

class TiresReplacement extends Component {

  componentWillMount() {
    const {uuid, connectedUserId, tiresReplacement, onChange} = this.props;
    if (uuid) {
      this.props.dispatchFetchJourneyTireOffers({uuid, connectedUserId})
    }

    const {tireOffer, brands = [], positions = {}, tireSize = {}, tireType = Constants.TIRE_REPLACEMENT_TYPE[0].value} = tiresReplacement;
    const defaultTiresReplacement = {brands, positions, tireSize, tireType, tireOffer};
    onChange(defaultTiresReplacement, false);
  }

  componentDidMount() {
    this.props.dispatchFetchTires();
  }

  handleDeletePhoto = () => {
    const {uuid, connectedUserId, intervention} = this.props;
    const { key } = intervention.tireOffers.attachment;
    this.props.dispatchDeleteJourneyTireOffers({uuid, connectedUserId, key, interventionId:intervention.id});
  };

  handleOnDocumentChange = (info) => {
    const {intervention, intervention: {journey}} = this.props;
    const form = new FormData();
    form.append("uuid", journey.uuid);
    form.append("tireOffers", info.file);
    this.props.dispatchSaveJourneyTireOffers(intervention.customer.id, form, intervention.id);
  };

  renderUploadTireOffer = (formatMessage) => {
    const {canWrite} = this.props;
    return (
      <Upload showUploadList={false} multiple={false} accept=".pdf"
              onChange={this.handleOnDocumentChange}
              beforeUpload={() => false}>
        {canWrite &&
        <button type="button" className="btn btn-sm btn-primary">{formatMessage({id: `appointment.detail.services.tireoffers.button.title`})}</button>
        }
      </Upload>
    )
  };


  onTireTypeChange = (e) => {
    const {tiresReplacement, onChange} = this.props;
    const {target: {name, value}} = e;
    tiresReplacement[name] = value;
    onChange(tiresReplacement);
  };

  onTireSizeChange = (name, number) => {
    const {tiresReplacement, onChange} = this.props;
    tiresReplacement.tireSize = tiresReplacement.tireSize || {};
    tiresReplacement.tireSize[name] = number;
    onChange(tiresReplacement);
  };

  onPositionChange = (e) => {
    const {tiresReplacement, onChange} = this.props;
    const {target: {name, checked}} = e;
    tiresReplacement.positions = tiresReplacement.positions || {};
    tiresReplacement.positions[name] = checked;
    onChange(tiresReplacement);
  };

  onBrandChange = (e) => {
    const {tiresReplacement, tiresReplacement: {brands = []}, onChange} = this.props;
    const {target: {name, checked}} = e;
    tiresReplacement.brands = brands.filter(b => b !== name);
    if (checked) {
      tiresReplacement.brands.push(name);
    }
    onChange(tiresReplacement);
  };

  renderTireBrands = () => {
    const {intl:{formatMessage}, canWrite, fetchTires: {tires: {mainBrands = {}, extraBrands = []} = {}}, tiresReplacement} = this.props;
    const {brands = []} = tiresReplacement;
    let allBrands = Object.values(mainBrands).filter(b => b.active === true).map(b => {return {key:b.name, label:formatMessage({id: `tires.${b.name}`})}});
    extraBrands.forEach(e => allBrands.push({key:e.name, label:e.name}));

    return allBrands.map(brand => {
      return (
        <Checkbox key={brand.key} name={brand.key} onChange={this.onBrandChange} checked={brands.includes(brand.key)} disabled={!canWrite}>
          {brand.label}
        </Checkbox>
      )
    });
  };

  renderTirePositions = (positions) => {
    const {intl: {formatMessage}, canWrite} = this.props;

    return Constants.TIRE_REPLACEMENT_POSITION.map(p => {
      return (
        <Checkbox key={p.value} name={p.value} checked={positions[p.value]} disabled={!canWrite} onChange={this.onPositionChange}>
          {formatMessage({id:p.label})}
        </Checkbox>
      )
    });
  };

  render() {
    const {intl:{formatMessage}, tiresReplacement, intervention: {tireOffers, journey: {properties = {}} = {}}, canWrite, errors} = this.props;
    const {tireSize = {}, positions = {}, tireOffer = {}} = tiresReplacement;
    const alertClassName = !tireOffer? 'is-alert' : '';

    const {services} = properties.services;
    const canUploadOffer = services.map(service => service.name).find(name => name === 'tiresReplacement');

    return (

        <div className={`box__body appointment-tires-infos ${alertClassName}`}>
          <header className="d-flex justify-content-between align-items-center mb-2">
            <h3 className="box__subtitle mb-0">{formatMessage({id:'appointment.detail.services.tires-replacement.title'})}</h3>
            {!tireOffers && canUploadOffer && this.renderUploadTireOffer(formatMessage)}
          </header>
          <ul className="list">
            <li style={{width: '15rem'}}>
              <SADropdown name="tireType" value={tiresReplacement.tireType} onChange={this.onTireTypeChange} disabled={!canWrite}
                          choices={Constants.TIRE_REPLACEMENT_TYPE.map(c => ({value: c.value, display: formatMessage({id: c.label})}))}/>
            </li>
            <li>
              {formatMessage({id:'appointment.detail.services.tires-replacement.position'})}: <br/>
              {this.renderTirePositions(positions)}
              {errors && errors[`tiresReplacement.positions`] &&
                <div className='txt-error'>{formatMessage({id: errors[`tiresReplacement.positions`].message})}</div>
              }
            </li>
            <li>
              {formatMessage({id:'appointment.detail.services.tires-replacement.brand'})}: <br/>
              {this.renderTireBrands()}
            </li>
            <li>
              {formatMessage({id:'appointment.detail.services.tires-replacement.size'})}: <br/>
              <SAInputNumber value={tireSize.width}  style={{maxWidth: '6rem'}} disabled={!canWrite}
                             onChange={value => this.onTireSizeChange("width", value)} max={999}/>{` / `}
              <SAInputNumber value={tireSize.profile} style={{maxWidth: '6rem'}} disabled={!canWrite}
                             onChange={value => this.onTireSizeChange("profile", value)} max={99}/>{` R `}
              <SAInputNumber value={tireSize.diameter} style={{maxWidth: '6rem'}} disabled={!canWrite}
                             onChange={value => this.onTireSizeChange('diameter', value)} max={99}/>
            </li>

            {tireOffers &&
              <li>
                {formatMessage({id:'appointment.detail.services.tireoffers.section.title'})}<br/>
                <div className="document-item">
                  <a href={tireOffer.url} target="_blank" className="document-item__link">
                    <svg className="document-item__icon">
                      <use xlinkHref="#icon-file-pdf"/>
                    </svg>
                    {tireOffer.filename}
                  </a>

                  {canWrite &&
                    <button className="document-item__delete" onClick={this.handleDeletePhoto}>
                      <svg className="document-item__delete-icon">
                        <use xlinkHref="#icon-cross-circle"/>
                      </svg>
                    </button>
                  }
                </div>
              </li>
            }
          </ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  fetchTires: state.fetchTires,
  intervention: state.fetchIntervention.intervention,
  tireOffers: state.tireOffers
});

const mapDispatchToProps = dispatch => ({
  dispatchFetchTires: () => dispatch({type: 'FETCH_TIRES.REQUEST'}),
  dispatchFetchJourneyTireOffers: (params) => dispatch({type: 'FETCH.JOURNEY_TIRE_OFFERS.REQUEST', ...params}),
  dispatchSaveJourneyTireOffers: (id, body, interventionId) => dispatch({type: 'SAVE.JOURNEY_TIRE_OFFERS.REQUEST', id, body, interventionId}),
  dispatchDeleteJourneyTireOffers: (params) => dispatch({type: 'DELETE.JOURNEY_TIRE_OFFERS.REQUEST',  ...params})
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(TiresReplacement))




// WEBPACK FOOTER //
// ./src/components/interventiondetail/services/TiresReplacement.js